import { defineStore } from 'pinia'
import { useApi } from '@/api/useApi'
import { useBaseStore } from '@haskoning/vue-basestore'
import API from '@/api/apiUrls'
import type { QuantityCode } from './type/quantityCode.type'

const serviceURL = API.CALCULATION.QUANTITY_CODES.INDEX

export const useQuantityCodeStore = defineStore('quantityCode', () => {
  const { api } = useApi()
  const baseStore = useBaseStore<QuantityCode>({ service: serviceURL, api })

  return {
    ...baseStore
  }
})
